import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initPosthog } from './analytics/posthog';
import { BrowserRouter } from 'react-router-dom';
import PrerenderApp from './PrerenderApp';

initPosthog();

const isReactSnap = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Temporarily disable StrictMode to verify double-render behavior in dev
  <BrowserRouter>
    {isReactSnap ? <PrerenderApp /> : <App />}
  </BrowserRouter>
);
